'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('@chakra-ui/react');

const ArrowRightIcon = react.createIcon({
  displayName: "ArrowRightIcon",
  path: /* @__PURE__ */ jsxRuntime.jsxs("g", { fill: "currentColor", children: [
    /* @__PURE__ */ jsxRuntime.jsx("path", { d: "M13.584,12a2.643,2.643,0,0,1-.775,1.875L3.268,23.416a1.768,1.768,0,0,1-2.5-2.5l8.739-8.739a.25.25,0,0,0,0-.354L.768,3.084a1.768,1.768,0,0,1,2.5-2.5l9.541,9.541A2.643,2.643,0,0,1,13.584,12Z" }),
    /* @__PURE__ */ jsxRuntime.jsx("path", { d: "M23.75,12a2.643,2.643,0,0,1-.775,1.875l-9.541,9.541a1.768,1.768,0,0,1-2.5-2.5l8.739-8.739a.25.25,0,0,0,0-.354L10.934,3.084a1.768,1.768,0,0,1,2.5-2.5l9.541,9.541A2.643,2.643,0,0,1,23.75,12Z" })
  ] })
});

exports.ArrowRightIcon = ArrowRightIcon;
